import theme from '@theme';
import styled from 'styled-components';

const Separator = styled.div`
  width: 0.25rem;
  height: 0.25rem;
  background: ${theme.palette.grey[300]};
  border-radius: 50%;
  margin-right: 0.375rem;
  margin-left: 0.375rem;
`;

export default Separator;
